var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shown),expression:"shown"}],staticClass:"c-modal-mask",attrs:{"transition":"modal"},on:{"click":_vm.close}},[_c('div',{staticClass:"c-modal-container",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }